export default __webpack_public_path__ + "static/media/betterlinks-icon.5c001a15.png";